if (!customElements.get('sticky-atc')) {
    customElements.define(
        'sticky-atc',
        class StickyAtc extends HTMLElement {
            observer;
            boundQuantityChange;
            boundVariantChange;
            priceElement;
            price;

            constructor() {
                super();
                this.priceElement = this.querySelector(".sticky__meta");
                if (this.priceElement) {
                    this.price = this.extractPrice(this.priceElement.textContent);
                    this.boundQuantityChange = this.observerQuantityChange.bind(this);
                    this.boundVariantChange = this.onVariantChange.bind(this);
                }
            }

            extractPrice(price) {
                return parseFloat(price.replace(/[^0-9.-]+/g, ""));
            }

            onVariantChange() {
                this.priceElement.textContent = this.getFormattedPrice(this.price);
            }

            // The shop's format can use any of Shopify's placeholders (this store's is
            // {{amount_no_decimals}}), not only {{amount}}; one left unmatched prints raw.
            getFormattedPrice(price) {
                return window.moneyWithCurrencyFormat
                    .replace(/\{\{\s*(\w+)\s*\}\}/, (_, placeholder) => this.formatAmount(price, placeholder))
                    .replace(Shopify.currency.active, "")
                    .trim();
            }

            formatAmount(price, placeholder) {
                const separators = {
                    amount_with_comma_separator: ['.', ','],
                    amount_no_decimals_with_comma_separator: ['.', ','],
                    amount_with_apostrophe_separator: ["'", '.'],
                    amount_with_space_separator: [' ', ','],
                    amount_no_decimals_with_space_separator: [' ', ','],
                    amount_with_period_and_space_separator: [' ', '.'],
                };
                const [thousands, decimal] = separators[placeholder] || [',', '.'];
                const [whole, fraction] = price.toFixed(placeholder.includes('no_decimals') ? 0 : 2).split('.');
                const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
                return fraction ? grouped + decimal + fraction : grouped;
            }

            observerQuantityChange(e) {
                if (e.target.tagName === 'INPUT' && e.target.name === 'quantity') {
                    const value = parseInt(e.target.value);
                    const newPrice = this.price * value;
                    this.priceElement.textContent = this.getFormattedPrice(newPrice);
                }
            }

            initObserver() {
                const buyBox = this.closest('product-info')?.querySelector('.product-form__submit');
                if (!buyBox || !('IntersectionObserver' in window)) return;
                this.observer = new IntersectionObserver(
                    (entries) => {
                        // records arrive oldest-first — the last one is current state
                        const entry = entries[entries.length - 1];
                        const passed = !entry.isIntersecting;
                        // && entry.boundingClientRect.bottom < 0;
                        this.classList.toggle('is-visible', passed);
                        if (passed) document.documentElement.style.setProperty('--sticky-atc-height', `${this.offsetHeight}px`);
                        document.documentElement.classList.toggle('sticky-atc-visible', passed);
                    },
                    {threshold: 0}
                );
                this.observer.observe(buyBox);
            }

            connectedCallback() {
                this.initObserver();
                window.addEventListener('change', this.boundQuantityChange);
                window.addEventListener('variantChange', this.boundVariantChange);
            }

            disconnectedCallback() {
                this.observer?.disconnect();
                window.removeEventListener('change', this.boundQuantityChange);
                window.removeEventListener('variantChange', this.boundVariantChange);
            }
        }
    );
}
